import cn from "classnames";
import Toggle from "components/shared/toggle";
import React from "react";
import PartyLookup from "./partyLookup";

const fieldNames = ["name", "inn", "kpp", "email", "phoneNumber", "ogrn", "address", "city", "street", "houseNumber"];

export default function DetailsForm({
    valid,
    loading,
    manual,
    setManual,
    renderField,
    renderSelect,
    onCancel,
    onSave,
    onSelect,
    title,
}) {
    const hasCancel = !!onCancel;

    return (
        <form
            className={cn("card card-body", {
                "mb-3": hasCancel,
                loading,
                "book-show__body--invalid": !valid,
            })}
            onSubmit={onSave}
        >
            {(title || hasCancel) && (
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {title && <h5 className="mb-0">{title}</h5>}
                    {hasCancel && (
                        <button className="btn btn-xs btn-link" type="button" onClick={onCancel}>
                            Отмена
                        </button>
                    )}
                </div>
            )}
            <div className="row form-group">
                <div className="col-sm-8 col-md-9 offset-sm-4 offset-md-3">
                    <Toggle
                        fieldBeforeLabel
                        value={!manual}
                        onChange={(value) => setManual(!value)}
                        label="Поиск по названию или ИНН"
                    />
                </div>
            </div>
            {!manual && <PartyLookup onSelect={onSelect} />}
            {fieldNames.map((name) => (
                <React.Fragment key={name}>{renderField(name)}</React.Fragment>
            ))}
            {renderSelect("ndsTypeId")}
            {renderSelect("paymentTypeId")}
            <div className={cn({ "d-flex justify-content-end": hasCancel })}>
                {hasCancel && (
                    <button className="btn btn-sm btn-secondary mr-2" type="button" onClick={onCancel}>
                        Отмена
                    </button>
                )}
                <button
                    className={cn("btn btn-sm btn-brand", { "float-right": !hasCancel })}
                    type="submit"
                    disabled={loading}
                >
                    Сохранить
                </button>
            </div>
        </form>
    );
}
